import Link from 'next/link';
import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { FiChevronRight, FiChevronLeft, FiSearch } from "react-icons/fi";


interface Slide {
  id: number;
  type: 'original' | 'new';
  bgClass: string;
  title: string;
  description?: string;
  subtitle?: string;
  image?: string;
  isBackgroundImage?: boolean;
  showAnimation?: boolean;
  titleClass?: string;
  btnClass?: string;
  admissionLink?: string;
  coursesLink?: string;
}

const HomeHeroSection: React.FC = () => {
  const swiperRef = useRef<any>(null);

  const slides: Slide[] = [
    {
      id: 1,
      type: 'original',
      bgClass: 'single-slider-bg-1',
      titleClass: 'one',
      btnClass: 'bnt1',
      title: "We Focus on Your Children's Development",
      description: "In addition to these core schools, students in a given country may also attend schools before and after primary elementary in the and secondary middle school in the us education. Kindergarten or preschool.",
      admissionLink: "/admission",
      coursesLink: "/special-class"
    },
    {
      id: 2,
      type: 'new',
      bgClass: 'banner-section style-1',
      subtitle: "Online education",
      title: "Your journey to excellence starts here with world-class education.",
      // description: "Free online courses from the world’s Leading experts. join 18+ million Learners today.",
      image: "/images/slider_hero_two.png",
      showAnimation: true,
    },
    {
      id: 3,
      type: 'new',
      bgClass: 'banner-section style-1',
      subtitle: "Online education",
      title: "Preparing Students For Success In A Changing World",
      // description: "Free online courses from the world’s Leading experts. join 18+ million Learners today.",
      image: "/images/hero_slider_third.webp",
      isBackgroundImage: true,
      showAnimation: false,
    }
  ];

  return (
    <section className="slider-area">
      <div className="home-slider">
        <Swiper
          ref={swiperRef}
          modules={[Autoplay, Navigation, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}

          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          speed={1000}
          className="owl-carousel owl-theme"
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              {slide.type === 'original' ? (
                <div className={`single-slider hero-responsive-padding ${slide.bgClass}`}>
                  <div className="d-table">
                    <div className="d-table-cell">
                      <div className="container">
                        <div className="row align-items-center">
                          <div className="col-lg-12 text-center">
                            <div className={`slider-tittle ${slide.titleClass}`}>
                              <h1>
                                We Focus on Your <span>Children&apos;s Development</span>
                              </h1>
                              <p>
                                {slide.description}
                              </p>
                            </div>
                            <div className={`slider-btn ${slide.btnClass} text-center`}>
                              <Link href={slide.admissionLink || "/"} className="box-btn">
                                Admission
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`single-slider hero-responsive-padding ${slide.bgClass} hero-slide-${slide.id}`}
                  style={slide.isBackgroundImage ? {
                    backgroundImage: `url(${slide.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat'
                  } : {}}
                >
                  <div className="container h-100">
                    <div className="section-wrapper h-100">
                      <div className="row align-items-center h-100">
                        <div className={slide.isBackgroundImage ? "col-lg-12 text-center" : "col-12 col-lg-7 col-xl-7 col-xxl-6"}>
                          <div className={`banner-content slider-tittle padding-0 ${slide.isBackgroundImage ? "text-center" : "text-lg-start text-center"}`} style={{ position: 'relative', zIndex: '20' }}>
                            <h1>
                              {slide.title}
                            </h1>
                            <p className="desc">
                              {slide.description}
                            </p>
                          </div>
                        </div>
                        {!slide.isBackgroundImage && (
                          <div className="col-12 col-lg-5 col-xl-5 col-xxl-6 mt-5 mt-lg-0 d-none d-lg-block">
                            <div className={`banner-thumb ${slide.showAnimation ? 'animation-img' : ''} text-center`}>
                              {slide.showAnimation && (
                                <>
                                  <div className="all-shapes"></div>

                                
                                </>
                              )}

                              <img src={slide.image} alt="Student" tabIndex={-1} className='position-img img-fluid' style={{ maxWidth: '100%', height: 'auto' }} />

                             
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}

          {/* Navigation buttons */}
          <div className="swiper-button-next"> <FiChevronRight /> </div>
          <div className="swiper-button-prev"><FiChevronLeft /></div>
        </Swiper>
      </div>
    </section >
  );
};

export default HomeHeroSection;
